import axios from 'axios';

const endpoint = process.env.VUE_APP_AWS_REGISTRATION_API_ENDPOINT;

const registerUser = async (body) => {
  try {
    return await axios.post(`${endpoint}/signup`, body);
  } catch (e) {
    throw e.response.data.errors[0];
  }
};

// only for testing
const withdrawUser = async (id) => {
  try {
    const body = {
      id,
    };
    return await axios.post(`${endpoint}/withdraw`, body);
  } catch (e) {
    throw e.response.data.errors[0];
  }
};

const completeRegistration = async (body) => {
  try {
    return await axios.put(`${endpoint}/complete-register`, body);
  } catch (e) {
    throw e.response.data.errors[0];
  }
};

const changePassword = async (body) => {
  try {
    return await axios.put(`${endpoint}/change-password`, body);
  } catch (e) {
    throw e.response.data.errors[0];
  }
};
export { registerUser, completeRegistration, changePassword, withdrawUser };
